import { useEffect } from "react";

const usePageTitle = title => {
  useEffect(() => {
    if (!title) return;
    const previousTitle = document.title;
    document.title = `${title} - Pleteo`;
    return () => {
      document.title = previousTitle;
    };
  }, [title]);
};

export default usePageTitle;
